import refs from 'bz-utilities/modules/legacy/refs';
import createReactClass from 'create-react-class';
import moment from 'moment';
import React from 'react';
import PublishMixin from '../../../../../../mixins/publish-mixin';

const dateIconStyle = {
  position: 'absolute',
  bottom: 2,
  right: 2,
  zIndex: 0,
  cursor: 'pointer'
};

const initWrapperStyle = {
  position: 'relative',
  marginTop: -15,
  height: '100%',
  width: '100%'
};

const inputStyle = {
  paddingRight: 20,
  paddingTop: 20,
  color: 'black'
};

const seperators = ['-', '/', '.'];

const seperatorKeycodes = [191, 111, 190, 110, 109, 189];

const DateInput = createReactClass({
  displayName: 'DateInput',
  mixins: [PublishMixin],

  getDefaultProps: function () {
    return {
      tabIndex: 0,
      format: 'DD/MM/YYYY',
      onBlur: () => {}
    };
  },

  getInitialState: function () {
    return {
      value: this.format(this.props.value),
      isValid: true
    };
  },

  UNSAFE_componentWillReceiveProps: function (nextProps) {
    const nextValue = this.format(nextProps.value);

    if (nextValue != this.state.value) {
      this.setState({
        value: nextValue
      });
    }
  },

  format(value) {
    return !!value ? moment(value).format(this.props.format) : '';
  },

  isValid(val) {
    const { length } = val;
    if (length == 2 && (parseInt(val.substring(0, 2)) > 31 || parseInt(val.substring(0, 2)) == 0)) {
      return false;
    }
    if (length == 3 && !seperators.includes(val.substring(2, 3))) {
      return false;
    }
    if (length == 5 && (parseInt(val.substring(3, 5)) > 12 || parseInt(val.substring(3, 5)) == 0)) {
      return false;
    }
    if (length == 6 && !seperators.includes(val.substring(5, 6))) {
      return false;
    }
    if (length == 9 && (parseInt(val.substring(6, 8)) > 20 || parseInt(val.substring(6, 8)) < 19)) {
      return false;
    }
    if (length == 11) {
      return false;
    }
    return true;
  },

  onChange(e) {
    const { value } = e.target;

    if (this.isValid(value)) {
      this.setState({
        value: value
      });
    }
  },

  onKeyDown(e) {
    const { keyCode } = e;
    const { value } = this.state;

    if (keyCode == 9) {
      setTimeout(() => this.props.onRequestClose(), 100);
    } else if (keyCode === 13) {
      e.preventDefault();
      this.update(value.split('/'));
      return;
    } else if (keyCode == 8) {
      const { length } = value;

      if ([3, 6].includes(length)) {
        this.setState({
          value: value.substring(0, length - 1)
        });
      }
    } else if (seperatorKeycodes.includes(keyCode)) {
      e.preventDefault();
      const values = [];
      const segments = value.split('/');
      if (segments.length === 3) {
        values.push(...segments);
      } else {
        if (segments.length < 3) {
          values.push(
            ...segments
              .map((x) => (!x || x === '0' ? '1' : x))
              .map((x) => (x.length === 1 ? `0${x}` : x))
          );
        }
        values.push('');
      }

      this.setState({
        value: values.join('/')
      });
    }

    this.setState({ isValid: true });
  },

  onBlur(e) {
    this.update(e.target.value.split('/'));
    this.props.onBlur();
  },

  update(values) {
    if (values.slice(-1)[0] == '') values.pop();

    const { length } = values;
    const currentDate = moment();

    if (length == 1) {
      values.push(currentDate.format('MM'));
      values.push(currentDate.year());
    } else if (length == 2) {
      values.push(currentDate.year());
    } else if (length == 3 && values[2].length < 4) {
      const digits = parseInt(values[2]);
      const prefix = digits > currentDate.year() % 2000 ? 1900 : 2000;

      values[2] = `${prefix + digits}`;
    }

    const value = values.join('/');

    const date = values.length === 0 ? undefined : moment(value, 'DD/MM/YYYY');
    this.setState({
      value: value,
      isValid: !!date ? date.isValid() : true
    });

    this.props.onChange(date);
  },

  render() {
    const wrapperStyle = Object.assign({}, initWrapperStyle, this.props.wrapperStyle);
    const style = Object.assign({}, this.props.style, inputStyle);

    if (!this.state.isValid) {
      style.color = '#D32F2F';
    }

    return (
      <div style={wrapperStyle} onClick={this.props.onClick}>
        <input
          type="text"
          ref={this._refs.dateInput}
          style={style}
          value={this.state.value}
          onChange={this.onChange}
          onFocus={this.props.onFocus}
          tabIndex={this.props.tabIndex}
          onKeyDown={this.onKeyDown}
          onBlur={this.onBlur}
          data-test-id={this.props['data-test-id']}
        />
        <i style={dateIconStyle} className="fa fa-calendar" />
      </div>
    );
  }
});

export default refs('dateInput')(DateInput);
